export default () => {
    return (
        <div className="loading">Loading</div>
    )
}